"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const Calendar = createSvgIcon(
  <path d="M4 21.0003V5.00031H7.3846V2.76953H8.46152V5.00031H15.6154V2.76953H16.6154V5.00031H20V21.0003H4ZM5 20.0003H19V10.6157H5V20.0003ZM5 9.61568H19V6.00031H5V9.61568Z" />,
  "Calendar",
)

const CalendarIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <Calendar sx={{ fill: _fill, ...sx }} {...rest} />
}

export default CalendarIcon
